/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Box_Label_RecipientInputs */

const vi_box_label_recipient = /** @type {(inputs: Box_Label_RecipientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Người nhận`)
};

/**

* @param {Box_Label_RecipientInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const box_label_recipient = /** @type {((inputs?: Box_Label_RecipientInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Box_Label_RecipientInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_box_label_recipient(inputs)
});